document.addEventListener("DOMContentLoaded", function () {
  const qtyInputWrapper = document.querySelector('[data-js-product-quantity]');
  const qtyInput = qtyInputWrapper.querySelector('input');
  if (qtyInput) {
    qtyInput.setAttribute('max', 5); 

    qtyInput.addEventListener('input', function () {
        setTimeout(() => {
            if (parseInt(qtyInput.value) > 5) {
                qtyInput.value = 5;
            }
            triggerVariantSelection(qtyInput.value);
        }, 200);
    });
  }

  const qtyPlus = qtyInputWrapper.querySelector('.product-quantity__plus');
  const qtyMinus = qtyInputWrapper.querySelector('.product-quantity__minus');

  if (qtyPlus && qtyMinus) {
    qtyPlus.addEventListener('click', function () {
        setTimeout(() => {
            let newQty = parseInt(qtyInput.value);
            if (newQty <= 5) {
              triggerVariantSelection(newQty);
            }
        }, 100);
    });

    qtyMinus.addEventListener('click', function () {
        setTimeout(() => {
            let newQty = parseInt(qtyInput.value);
            if (newQty >= 1) {
                triggerVariantSelection(newQty);
            }
        }, 100);
    });
  }

  function triggerVariantSelection(quantity) {
    const variantItems = document.querySelectorAll('.product-variant__item input[type="radio"]');
    variantItems.forEach(function (radio) {
      console.log("This some event")
      const radioValue = radio.value;
      const variantQty = parseInt(radioValue.split(' ')[0]); 
      radio.parentElement.classList.remove("selected");

      if (variantQty === quantity) {
        console.log(quantity == 40)
        radio.parentElement.querySelector("label").click();
        radio.parentElement.classList.add("selected");

        // TODO: improve
        if(quantity == 40 || quantity == 15) {
          const quantityWrapper = radio.closest("product-page").querySelector('.product-quantity');

          const minusButton = quantityWrapper.querySelector('.product-quantity__minus');
          const plusButton = quantityWrapper.querySelector('.product-quantity__plus');
          const input = quantityWrapper.querySelector('input[type="number"]');

          // minusButton.disabled = true;
          // plusButton.disabled = true;
          input.disabled = true;

          quantityWrapper.style.opacity = '0.5';
          // quantityWrapper.style.pointerEvents = 'none'; 
        }
        else {
          const quantityWrapper = radio.closest("product-page").querySelector('.product-quantity');

          const minusButton = quantityWrapper.querySelector('.product-quantity__minus');
          const plusButton = quantityWrapper.querySelector('.product-quantity__plus');
          const input = quantityWrapper.querySelector('input[type="number"]');

          minusButton.disabled = false;
          plusButton.disabled = false;
          input.disabled = false;

          quantityWrapper.style.opacity = '';
          quantityWrapper.style.pointerEvents = ''; 
        }
      }

      // temporary solution
    });
  }

  const bulkOptions = document.querySelectorAll('.product-variant__item input[type="radio"]');
  bulkOptions.forEach(function (radio) {
    radio.addEventListener('click', function () {
      const value = radio.value;
      const qty = parseInt(value.split(' ')[0]);
      if (qty >= 15) { 
        triggerVariantSelection(qty);
      }
    });
  });
});
